export default __webpack_public_path__ + "ecfd3711d1dadb05cf64bed6aa141e0e.svg";